module.exports = __webpack_public_path__ + "static/img/b05.e3d0399.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/b05.jpg
// module id = l1io
// module chunks = 1